module.exports = __webpack_public_path__ + "img/Wp_2016.6f176a63.png";